<template>
  <div>
    <form-input-container title='Type Beslissing' text='Welke beslissing heeft UWV genomen?'>
      <dropdown v-model="decisionType">
        <option v-for="uwvDecisionType in uwvDecisionTypes"
          :value="uwvDecisionType"
          :key="'uwv-d-t-'+uwvDecisionType">
          {{ 'uwv-decision.types.'+uwvDecisionType | translate }}
        </option>
      </dropdown>
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.decision-date')" :text="$t('uwv-decision.fields.guides.decision-date')">
      <date-picker v-model="decisionDate" />
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.start-date')" :text="$t('uwv-decision.fields.guides.start-date')">
      <date-picker v-model="startDate" />
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.disability-rate')" :text="$t('uwv-decision.fields.guides.disability-rate')">
      <text-field right v-model="disabilityRate" @change="handleDisabilityRateChanged()"
        :errors="validations.messagesFor('disabilityRate')" placeholder="XXX,XX">
        <p slot="right">%</p>
      </text-field>
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.wia-monthly-wage')" :text="$t('uwv-decision.fields.guides.wia-monthly-wage')">
      <text-field right v-model="wiaMonthlyWage" @change="handleWiaMonthlyWageChanged()">
        <v-icon slot='right'>euro_symbol</v-icon>
      </text-field>
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.wia-daily-wage')" :text="$t('uwv-decision.fields.guides.wia-daily-wage')">
      <text-field right optional v-model="wiaDailyWage" @change="handleWiaDailyWageChanged()">
        <v-icon slot='right'>euro_symbol</v-icon>
      </text-field>
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.benefit-end-date')" :text="$t('uwv-decision.fields.guides.benefit-end-date')">
      <date-picker v-model="benefitEndDate" optional clearable />
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.income-from-work')" :text="$t('uwv-decision.fields.guides.income-from-work')">
      <text-field right v-model="incomeFromWork" optional @change="handleIncomeFromWorkChanged()">
        <v-icon slot='right'>euro_symbol</v-icon>
      </text-field>
    </form-input-container>

    <form-input-container :title="$t('uwv-decision.fields.attachment')" :text="$t('uwv-decision.fields.guides.attachment')">
      <multiple-file-upload placeholder="Upload Bestand" accept='.pdf' v-model="attachments">
        <v-icon slot="left">assignment</v-icon>
      </multiple-file-upload>
      <span style='float: right; font-size: 0.9em; margin-top: 5px;'>max. 20MB, enkel *.pdf</span>
    </form-input-container>
  </div>
</template>

<script>
import { UwvDecisionTypes } from '@/resources/models/uwv-decisions';
import Helpers from '@/shared/helpers/functions';

import NewUwvDecision from '@/views/constants/uwv-decision-new';

import Dropdown from '@aevitae/aevitaeui/0_atoms/input/Dropdown.vue';
import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';
import MultipleFileUpload from '@aevitae/aevitaeui/0_atoms/input/MultipleFileUpload.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';


export default {
  name: 'UwvDecisionForm',
  data () {
    return {
      uwvDecisionTypes: UwvDecisionTypes
    };
  },
  props: {
    isEditing: Boolean
  },
  components: {
    Dropdown,
    TextField,
    MultipleFileUpload,
    FormInputContainer,
    DatePicker
  },
  computed: {
    uwvDecision () {
      if (this.isEditing) {
        return this.$store.getters.newUwvDecision;
      } else {
        return this.$store.getters.newUwvDecision;
      }
    },

    validations () {
      if (this.isEditing) return this.$store.getters.newUwvDecisionValidations;
      else return this.$store.getters.newUwvDecisionValidations;
    },

    decisionType: {
      get () { return this.uwvDecision.decisionType; },
      set (v) { this.dispatchChange('decisionType', v); }
    },
    disabilityRate: {
      get () {
        return this.uwvDecision.disabilityRate;
      },
      set (v) {
        if (v != null) v = v.replace('.', ',');
        this.dispatchChange('disabilityRate', v);
      }
    },
    startDate: {
      get () { return this.uwvDecision.startDate; },
      set (v) { this.dispatchChange('startDate', v); }
    },
    reportDate: {
      get () { return this.uwvDecision.reportDate; },
      set (v) { this.dispatchChange('reportDate', v); }
    },
    benefitEndDate: {
      get () { return this.uwvDecision.benefitEndDate; },
      set (v) { this.dispatchChange('benefitEndDate', v); }
    },
    decisionDate: {
      get () { return this.uwvDecision.decisionDate; },
      set (v) { this.dispatchChange('decisionDate', v); }
    },
    wiaDailyWage: {
      get () { return this.uwvDecision.wiaDailyWage; },
      set (v) { this.dispatchChange('wiaDailyWage', v); }
    },
    wiaMonthlyWage: {
      get () { return this.uwvDecision.wiaMonthlyWage; },
      set (v) { this.dispatchChange('wiaMonthlyWage', v); }
    },
    incomeFromWork: {
      get () { return this.uwvDecision.incomeFromWork; },
      set (v) { this.dispatchChange('incomeFromWork', v); }
    },
    attachments: {
      get () { return this.uwvDecision.attachments; },
      set (v) { this.dispatchChange('attachments', v); }
    }
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),

    dispatchChange (attribute, value) {
      if (this.isEditing) {
      } else {
        this.$store.dispatch(NewUwvDecision.Actions.Form.CHANGE, {
          attribute: attribute,
          value: value
        }).then(this.$store.dispatch(NewUwvDecision.Actions.Steps.Completed.UPDATE));
      }
    },

    handleWiaMonthlyWageChanged () {
      this.wiaMonthlyWage = Helpers.Percentage.formatAfterChange(this.wiaMonthlyWage);
    },
    handleWiaDailyWageChanged () {
      if (this.wiaDailyWage != null) {
        this.wiaDailyWage = Helpers.Percentage.formatAfterChange(this.wiaDailyWage);
      } else this.wiaDailyWage = null;
    },
    handleDisabilityRateChanged () {
      this.disabilityRate = Helpers.Percentage.formatAfterChange(this.disabilityRate);
    },
    handleIncomeFromWorkChanged () {
      this.incomeFromWork = Helpers.Percentage.formatAfterChange(this.incomeFromWork);
    }
  }
};
</script>
